module.exports = __webpack_public_path__ + "img/verification-process-2.beb8bb16.png";